// extracted by mini-css-extract-plugin
export default {"title":"RevenueOfEventSummary_title__P+WEj","total":"RevenueOfEventSummary_total__ESHmt","table":"RevenueOfEventSummary_table__F4O+Q"};